export enum DraggableOptions {
  LifeArea = 'life-area',
  Goal = 'goal',
  GoalSection = 'goal-section',
  SmartList = 'smart-list',
  Tag = 'tag',
  Task = 'task',
}
